<template>
    <div>
        <app-input
            type="switch"
            v-model="switchValue"
            @change="updateConfirmed($event.target.value)"
        />
    </div>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {axiosPost} from "../../../../common/Helper/AxiosHelper";

export default {
    name  : "SalarySheetConfirmed",
    mixins: [FormHelperMixins],
    props : {
        value  : {},
        tableId: {},
        rowData: {},
    },
    computed: {
        switchValue() {
            return parseInt(this.value);
        },
    },
    methods: {
        updateConfirmed(value) {
            this.rowData.status = value === 'false' ? 0 : 1;

            axiosPost(`${TENANT_BASE_URL}app/salary-sheet/${this.rowData.id}/status`, this.rowData).then((res) => {
                this.$toastr.s(res.data.message)
            }).catch((error) => {
                this.$toastr.e(error.response.data.message)
                this.switchValue = parseInt(this.value);
            })
        },
    }
}
</script>